import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5afbcc50"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5afbcc50&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afbcc50')) {
      api.createRecord('5afbcc50', component.options)
    } else {
      api.reload('5afbcc50', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5afbcc50", function () {
      api.rerender('5afbcc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projectSelect/index.vue"
export default component.exports